const gallerySimple = document.querySelectorAll('.shopify-section.gallery-simple');

gallerySimple.forEach((elem) => {

  const gallerySimpleHolder = elem.querySelector('.gallery-simple-images');

  const gallerySimpleImgHolder = elem.querySelectorAll('.gallery-simple-images li');

  gsap.set(gallerySimpleImgHolder, {xPercent: -50, yPercent: -50});

  const ball = gallerySimpleImgHolder;

  ball.forEach((elem, index) => {

    let delay = index * 150;

    const pos = { x: window.innerWidth / 2, y: window.innerHeight / 2 };
    const mouse = { x: pos.x, y: pos.y };
    const speed = 0.2;

    const xSet = gsap.quickTo(elem, "x", {duration: .1, ease: 'power3'});
    const ySet = gsap.quickTo(elem, "y", {duration: .1, ease: 'power3'});

    window.addEventListener("mousemove", e => {

      setTimeout(() => {
        mouse.x = e.x;
        mouse.y = e.y;
      }, delay);
    });

    gsap.ticker.add(() => {
      const dt = 1.0 - Math.pow(1.0 - speed, gsap.ticker.deltaRatio());

      pos.x += (mouse.x - pos.x) * dt;
      pos.y += (mouse.y - pos.y) * dt;
      xSet(pos.x);
      ySet(pos.y);
    });

  });
  const tl = gsap.timeline({
    paused: true
  });

  tl.to(gallerySimpleImgHolder, 3, {
    scale: 1,
    ease: 'power3.inOut',
    stagger: .5,
    scrollTrigger: {
      trigger: elem,
      start: "top 75%",
      end: "bottom 50%",
      scrub: 3,
      markers: false
    }
  });
});
